<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div id="ProvisioningTemplateDialog" mat-dialog-title appLifecycleTracker trackerName="provisioning-template-dialog">
  <span class="dialog-title">{{'provision-template.title' | translate}}</span>
  <div class="dialog-sub-title">{{'provision-template.subtitle' | translate}}</div>
</div>
<mat-dialog-content>
    <form id="provisioningForm" [formGroup]="provisioningForm">
        <div class="title-subsection-wrapper">
            <div class="provision-section-title">{{ 'provision-template.drive-size-title' | translate }}</div>
            <div class="section-sub-title">{{ 'provision-template.drive-size-subtitle' | translate }}</div>
        </div>

        <div class="drive-size-wrapper">
            <span class="drive-size-label">256 GB</span>
            <mat-form-field appearance="outline" class="drive-size-input">
                <input id="drive256GBInput" matInput type="text" inputmode="numeric" formControlName="drive256GB"
                       value=""/>
            </mat-form-field>
            <span class="percent-sign"><span *ngIf="ctrls.drive256GBPercent.value">%</span></span>
            <mat-form-field appearance="outline">
                <mat-select formControlName="drive256GBPercent" [value]=true
                            (valueChange)="onDriveSizeUnitChange($event)">
                    <mat-option [value]=true>{{ 'provision-template.drive-size-option1' | translate }}</mat-option>
                    <mat-option [value]=false>{{ 'provision-template.drive-size-option2' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="formCtrls.drive256GB.errors?.required" class="inline-error">
                {{'provision-template.drive-size-required' | translate}}
            </mat-error>
        </div>

        <div class="drive-size-wrapper">
            <span class="drive-size-label">512 GB</span>
            <mat-form-field appearance="outline" class="drive-size-input">
                <input id="drive512GBInput" matInput type="text" inputmode="numeric" formControlName="drive512GB"
                       value=""/>
            </mat-form-field>
            <span class="percent-sign"><span *ngIf="ctrls.drive512GBPercent.value">%</span></span>
            <mat-form-field appearance="outline">
                <mat-select formControlName="drive512GBPercent" [value]=true
                            (valueChange)="onDriveSizeUnitChange($event)">
                    <mat-option [value]=true>{{ 'provision-template.drive-size-option1' | translate }}</mat-option>
                    <mat-option [value]=false>{{ 'provision-template.drive-size-option2' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="formCtrls.drive512GB.errors?.required" class="inline-error">
                {{'provision-template.drive-size-required' | translate}}
            </mat-error>
        </div>

        <div class="drive-size-wrapper">
            <span class="drive-size-label">1 TB</span>
            <mat-form-field appearance="outline" class="drive-size-input">
                <input id="drive1TBInput" matInput type="text" inputmode="numeric" formControlName="drive1TB" value=""/>
            </mat-form-field>
            <span class="percent-sign"><span *ngIf="ctrls.drive1TBPercent.value">%</span></span>
            <mat-form-field appearance="outline">
                <mat-select formControlName="drive1TBPercent" [value]=true
                            (valueChange)="onDriveSizeUnitChange($event)">
                    <mat-option [value]=true>{{ 'provision-template.drive-size-option1' | translate }}</mat-option>
                    <mat-option [value]=false>{{ 'provision-template.drive-size-option2' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="formCtrls.drive1TB.errors?.required" class="inline-error">
                {{'provision-template.drive-size-required' | translate}}
            </mat-error>
        </div>

        <div class="drive-size-wrapper">
            <span class="drive-size-label">2 TB</span>
            <mat-form-field appearance="outline" class="drive-size-input">
                <input id="drive2TBInput" matInput type="text" inputmode="numeric" formControlName="drive2TB" value=""/>
            </mat-form-field>
            <span class="percent-sign"><span *ngIf="ctrls.drive2TBPercent.value">%</span></span>
            <mat-form-field appearance="outline">
                <mat-select formControlName="drive2TBPercent" [value]=true
                            (valueChange)="onDriveSizeUnitChange($event)">
                    <mat-option [value]=true>{{ 'provision-template.drive-size-option1' | translate }}</mat-option>
                    <mat-option [value]=false>{{ 'provision-template.drive-size-option2' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="formCtrls.drive2TB.errors?.required" class="inline-error">
                {{'provision-template.drive-size-required' | translate}}
            </mat-error>
        </div>

        <div class="drive-size-wrapper">
            <span class="drive-size-label">4 TB</span>
            <mat-form-field appearance="outline" class="drive-size-input">
                <input id="drive4TBInput" matInput type="text" inputmode="numeric" formControlName="drive4TB" value=""/>
            </mat-form-field>
            <span class="percent-sign"><span *ngIf="ctrls.drive4TBPercent.value">%</span></span>
            <mat-form-field appearance="outline">
                <mat-select formControlName="drive4TBPercent" [value]=true
                            (valueChange)="onDriveSizeUnitChange($event)">
                    <mat-option [value]=true>{{ 'provision-template.drive-size-option1' | translate }}</mat-option>
                    <mat-option [value]=false>{{ 'provision-template.drive-size-option2' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="formCtrls.drive4TB.errors?.required" class="inline-error">
                {{'provision-template.drive-size-required' | translate}}
            </mat-error>
        </div>

        <div class="provision-section-title">{{ 'provision-template.password-text' | translate }}</div>
        <mat-radio-group formControlName="diskPasswordSetting" class="password-radio-group"
                         aria-label="Select a secure drive password option"
                         (change)="onDiskPasswordModeChanged($event)">
            <mat-radio-button class="radio-button" [value]="diskPasswordSettingType.AUTO_GENERATE">
                <span class="auto-label">{{ 'provision-template.password-option1' | translate }}</span>{{ 'provision-template.password-option1a' | translate }}
            </mat-radio-button>
            <!-- This is temporarily commented out
                <div class="specific-pass-wrapper">
                  <mat-radio-button class="radio-button" [value]="diskPasswordSetting.USER_SUPPLIED">{{'provision-template.password-option2' | translate}}</mat-radio-button>
                  <mat-form-field appearance="outline">
                    <input autocomplete="drive-password" id="secure-drive-password-input" type="password" class="pass-input"
                           formControlName="diskPassword" matInput placeholder="8 - 32 characters"
                           [disabled]="true" />
                  </mat-form-field>
                  <div class="pass-text">
                    <div>Your password must have at least one character from these categories:</div>
                    <div>Symbol (!@#$%^&*) Number (0-9) Lower case letter (a-z)</div>
                    <div>Upper case letter (A-Z) Length (8-32)</div>
                  </div>
                </div> -->
        </mat-radio-group>

        <div class="provision-section-title">{{ 'provision-template.protection-mode-text' | translate }}</div>
        <mat-radio-group formControlName="protectionMode" class="protection-mode-radio-group"
                         aria-label="Select a protection mode option"
                         (change)="onProtectionModeChanged()">
            <mat-radio-button class="radio-button"
                              [value]="diskProtectionMode.SINGLE_DURING_THREATS">{{ 'provision-template.protection-mode-option1' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-button"
                              [value]="diskProtectionMode.SINGLE_ALWAYS">{{ 'provision-template.protection-mode-option2' | translate }}
            </mat-radio-button>
            <mat-radio-button class="radio-button"
                              [value]="diskProtectionMode.DUAL_BOTH">{{ 'provision-template.protection-mode-option3' | translate }}
            </mat-radio-button>
        </mat-radio-group>

        <div class="provision-section-title same-line">{{ 'provision-template.ransomware-text' | translate }}</div>
        <mat-slide-toggle
                formControlName="diskRansomware"
                labelPosition="before"
                aria-labelledby="enable-usb-toggle"
                color="primary"
                id="enable-ransomware-detection-toggle"
                [disableRipple]="true"
                (change)="onRansomwareDetectionChange($event.checked)"
                [checked]="enableRansomwareDetection">
            {{ enableRansomwareDetection ? ('ON' | translate) : ('OFF' | translate) }}
        </mat-slide-toggle>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="provisioning-button-wrapper">
        <button (click)="onCancelTemplate()" type="button" mat-raised-button>{{ 'CANCEL' | translate }}</button>
        <button (click)="onSaveTemplate()" type="submit" mat-raised-button
                color="primary">{{ 'SAVE' | translate }}
        </button>
    </div>
</mat-dialog-actions>